export default __webpack_public_path__ + "static/media/tab-web-black.d27f785f.svg";